/**
 * Stats New feature constants
 */

/**
 * Maximum number of items to fetch from API when we need "all" items.
 * This is used for project groups fetch to get thumbnails.
 * Set to a very high value to effectively fetch all items.
 */
export const STATS_FETCH_ALL_LIMIT = 10000;

/**
 * Default page size for paginated charts (e.g., TopParcoursChart)
 */
export const DEFAULT_CHART_PAGE_SIZE = 5;

/**
 * Content types that are considered "scenes" and should be filtered out
 * from session interaction details.
 * Uses exact match to avoid filtering out content_scoring_scene, content_hotspot_scene_*, etc.
 */
export const SCENE_CONTENT_TYPES = [
  "content_scene",
  "scene",
  "360_scene",
  "content_360_scene",
] as const;

/**
 * Minimum session duration in seconds for a session to be counted in statistics.
 * Sessions shorter than this are excluded from stats and billing (for new sessions).
 */
export const MIN_SESSION_DURATION = 30;

/**
 * Cutoff date for the 30s duration rule.
 * Sessions created before this date are always included in stats (legacy behavior).
 * Sessions created after this date must have duration >= 30s to appear.
 */
export const DURATION_RULE_CUTOFF_DATE = new Date("2026-02-11T00:00:00Z");
